import { useMemo } from 'react';

import ApiCalls from '../../components/api/apiCalls';
import ElementUIsService from '../../components/services/ElementUIsService';

const useElementUIsService = () => {
  return useMemo(() => new ElementUIsService(new ApiCalls()), []);
};

export default useElementUIsService;
